// Components
import { Button, IconCheckmark } from '@tracklib/kit'
import { motion, AnimatePresence } from 'framer-motion'
import Modal from 'components/modal'

import styles from './successmessage.css'

const animation = {
  enter: {
    y: 0,
    scale: 1,
    opacity: 1,
    originX: '50%',
    transition: {
      type: 'spring',
      stiffness: 250,
      damping: 30,
    },
  },
  exit: {
    y: -100,
    scale: 0.8,
    opacity: 0,
    originX: '50%',
  },
}

type SuccessMessageProps = {
  title: string
  subtitle?: string
  isOpen: boolean
  close: () => void
  transitionDuration?: number
  clickToClose?: boolean
  buttonText?: string
}

const SuccessMessage = ({
  title,
  subtitle,
  isOpen,
  close,
  transitionDuration = 0.5,
  clickToClose,
  buttonText,
}: SuccessMessageProps): JSX.Element => (
  <Modal isOpen={isOpen} className={styles.wrapper} backdropClassName={styles.backdrop} transitionDuration={transitionDuration}>
    {clickToClose && (
      <button onClick={() => close()} className={styles.close}>
        Close
      </button>
    )}
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={styles.content}
          animate={animation.enter}
          exit={animation.exit}
          initial={animation.exit}
          key="successChildren"
        >
          <IconCheckmark className={styles.icon} />
          <h1 className={styles.title}>{title}</h1>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          {buttonText && <Button onClick={() => close()}>{buttonText}</Button>}
        </motion.div>
      )}
    </AnimatePresence>
  </Modal>
)

export default SuccessMessage
